import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const ProgressRoot = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level3};
  min-width: 0;
`;

export const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding: 3px 10px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.surfaceContainerHighest};
  box-shadow: inset 0 0 0 1px color-mix(in srgb, ${({ theme }) => theme.colors.primary} 35%, transparent);
`;

export const SpinningIcon = styled.svg`
  flex: none;
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.colors.primary};
  animation: ${spin} 1s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const ProgressText = styled.span`
  min-width: 0;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.onSurface};
`;
